"use strict";

import { swup } from "./swup.js";

const root = document.documentElement;
const loader = document.querySelector("[data-site-loader]");

if (loader) {
    const applyDebugFlag = () => {
        if (window.__loaderDebug === true) {
            root.dataset.loaderDebug = "1";
        }
    };

    const isDebug = () => {
        return window.__loaderDebug === true || root.dataset.loaderDebug === "1";
    };

    const showLoader = () => {
        if (isDebug()) return;
        document.body?.classList.remove("is-loaded");
    };

    const hideLoader = () => {
        if (isDebug()) return;
        document.body?.classList.add("is-loaded");
    };

    window.__setLoaderDebug = (value = true) => {
        if (value) {
            root.dataset.loaderDebug = "1";
            document.body?.classList.remove("is-loaded");
        } else {
            delete root.dataset.loaderDebug;
            document.body?.classList.add("is-loaded");
        }
    };

    applyDebugFlag();

    if (document.readyState === "complete") {
        hideLoader();
    } else {
        window.addEventListener("load", hideLoader, { once: true });
    }

    swup.hooks.on("visit:start", showLoader);
    swup.hooks.on("page:view", hideLoader);
}
